export const initialStore = {
  calculatorData: {
    portOperation: [],
    fleetList: [],
    clientQuery: {},
    cargoList: [],
    cargoExtraDetails: [],
    autoSave: false,
  },
  selectedVessels: {},
  syncBunker: false,
  isOverride: false,
  portDistanceResponse: {},
  realPortDistanceResponse: {},
  portDistancePayloadResponse: {},
  vesselOutContract: {},
  rawEstimateContract: {},
  isPrivate: false,
};
